import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { tx } from "@/i18n/tx";

// Copies a whole information block with explicit feedback. Falls back to a temporary textarea
// where the async Clipboard API is unavailable (older mobile browsers / non-secure contexts).
export async function copyText(text) {
  try {
    if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(text); return true; }
  } catch { /* fall through */ }
  try {
    const ta = document.createElement("textarea");
    ta.value = text; ta.setAttribute("readonly", ""); ta.style.position = "fixed"; ta.style.opacity = "0";
    document.body.appendChild(ta); ta.select(); const ok = document.execCommand("copy"); ta.remove();
    return ok;
  } catch { return false; }
}

export function CopyButton({ text, label = "Kopiera", size = "sm", className = "", testid = "copy-button" }) {
  const [done, setDone] = useState(false);
  const onCopy = async () => {
    const ok = await copyText(typeof text === "function" ? text() : text);
    if (ok) { setDone(true); toast.success(tx("Kopierat till urklipp.")); setTimeout(() => setDone(false), 1800); }
    else toast.error(tx("Kunde inte kopiera – markera texten och kopiera manuellt."));
  };
  return (
    <Button type="button" variant="ghost" size={size} onClick={onCopy} className={className} data-testid={testid} aria-label={label}>
      {done ? <Check className="h-3.5 w-3.5 text-emerald-600" /> : <Copy className="h-3.5 w-3.5" />} {tx(label)}
    </Button>
  );
}
